import { IntegrationsState } from './types';

export const initialState: IntegrationsState = {
  availableInstances: [],
  loadingIntegrations: false,
  rsvpLinkSync: null,
  loadingRSVPLinkSync: false,
  solutions: [],
  mappedSolutions: {},
  loadingSolutions: false,
};
